
import { CLIENT_SOFTWARE } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }
    switch (action.type) {
        case CLIENT_SOFTWARE.GET.INITIATE:
            return {isFetching: false};
        case CLIENT_SOFTWARE.GET.SUCCESS:
            return {isFetching: true, data: action.payload};
        case CLIENT_SOFTWARE.GET.ERROR:
            return action.payload;
        default:
            return state;
    }
};
